import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  text: 'Con la limpieza energética se me abrió la cabeza. Me hizo ver cosas de mi vida que tenía que cambiar. Me llevó a tomar decisiones drásticas — dar un giro de 180 grados. Así lo hice y hoy estoy en paz y feliz conmigo misma por haberme animado a dar este paso. Estoy orgullosa de mí.',
  author: 'Cliente, Argentina'
}, {
  text: 'La limpieza energética fue para mí una experiencia tranquila y liberadora. Al principio sentí muchas ganas de llorar, como si necesitara soltar todo lo que venía guardando. Me permití hacerlo, y poco a poco empecé a sentirme más liviana. Al final me quedé con una sensación de calma y claridad, como si algo se hubiera ordenado dentro mío. Y siento que este proceso aún continúa, acompañándome de a poco en el día a día.',
  author: 'Cliente, Argentina'
}, {
  text: 'Mi experiencia fue hermosa. Descubrí talentos ocultos y me sirvió para entender muchos de mis comportamientos que mantenía en automático en el inconsciente. Me dio mucha paz y felicidad — fue conocer una parte de mí que estaba muy conectada con ser, en sintonía con el universo.',
  author: 'Cliente, Argentina'
}, {
  text: 'Me pegó fuerte, en el buen sentido. Me ayudó a ver cosas que tenía ahí dando vueltas y no terminaba de entender. Salí más liviano, con otra claridad y con la sensación de haber soltado bastante. Se nota la dedicación y cómo lo hacés, con respeto y mucha conexión.',
  author: 'Cliente, Argentina'
}, {
  text: 'Describir y ponerle nombre a lo que sentía me trajo paz. El cambio fue total.',
  author: 'Cliente, Argentina'
}, {
  text: 'Gracias por el hermoso trabajo que hiciste para mí y mi hija. Tu dedicación y valentía son inspiradoras y tu capacidad para transformar es un don.',
  author: 'Cliente, Argentina'
}];
export function Testimonials() {
  return <section className="w-full bg-cream py-24 px-6" data-id="element-482">
      <div className="max-w-7xl mx-auto" data-id="element-483">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-teal text-3xl md:text-4xl lg:text-5xl text-center mb-16" data-id="element-484">
          Testimonios
        </motion.h2>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8" data-id="element-485">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="break-inside-avoid bg-white p-8 rounded-2xl shadow-sm border border-teal/5" data-id="element-486">
              <Quote className="text-teal mb-4" size={32} strokeWidth={1.5} data-id="element-487" />
              <p className="font-serif italic text-gray-700 text-lg leading-relaxed mb-6" data-id="element-488">
                "{testimonial.text}"
              </p>
              <p className="text-gray-400 text-sm tracking-wide" data-id="element-489">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}